import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=0e8b31e4"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e8b31e4')) {
      api.createRecord('0e8b31e4', component.options)
    } else {
      api.reload('0e8b31e4', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=0e8b31e4", function () {
      api.rerender('0e8b31e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/Wrapper.vue"
export default component.exports